<template>

  <div class="group" :ref="refs.productLayoutIdGroup" v-if="builder.productLayoutOptions.length > 1">

    <div class="group-header">
      <div class="group-title">Choose your kitchen shape:</div>
    </div>

    <Plan-Selector
      :key=builder.productLayouts.fieldName
      :field-name=builder.productLayouts.fieldName
      :display-type=builder.productLayouts.displayType
      :selected=builder.currentItem[builder.productLayouts.fieldName]
      options-source="kitchenLayoutOptions"
      @select-option="selectProductLayout"
    ></Plan-Selector>

    <div class="opts">

      <a href="/products/kitchens/submit-custom-kitchen-design-layout/" class="opt l_delivery l_full-width">
        <div class="opt-inner">
          <div class="opt-header">
            <div class="opt-title">
              <div class="opt-icon">
                <svg class="icon"><use xlink:href="#help"></use></svg>
              </div>
              <p>Can't see what you're looking for? <strong>Submit a custom quote.</strong></p>
            </div>
          </div>
        </div>
      </a>

    </div>

    <div class="opts" v-if="builder.isCp||builder.testMode">

      <button type="button" class="opt l_delivery l_full-width" @click="createCustomKitchen">
        <div class="opt-inner">
          <div class="opt-header">
            <div class="opt-title">
              <div class="opt-icon">
                <svg class="icon"><use xlink:href="#layout"></use></svg>
              </div>
              <p><strong>CP ONLY: Custom Kitchen</strong></p>
            </div>
          </div>
        </div>
      </button>

    </div>

  </div>

  <div class="wardrobenotice" v-if="isChangingLayout">
    <div class="wardrobenotice-inner">
      Changing your the kitchen type may mean selections you have previously saved are overwritten.
    </div>
  </div>

</template>

<script setup>
import { ref, onMounted, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

let tempProductLayoutIds = ref([]);
let tempProductLayoutSelection = ref(null);
let tempProductLayoutNoIslandIds = ref([]);
let tempProductLayoutWithIslandIds = ref([]);
let originalProductLayoutId = builder.currentItem.productLayoutId;

onMounted(() => {

  // if a productId and productLayoutId are already saved for the item, save it temporarily so the user won't lose it if they switch
  if (builder.currentItem.productId && builder.currentItem.productLayoutId) {
    tempProductLayoutIds.value[builder.currentItem.productId] = builder.currentItem.productLayoutId;
  }

  builder.setCurrentItemProp(builder.products.fieldName, 3)

  for (let i = 0; i < builder.productLayoutOptions.length; i ++) {
    const shortTitle = builder.productLayoutOptions[i].title.replace(' with Island', '');
    if (builder.productLayoutOptions[i].title.search('with Island') !== -1) {
      tempProductLayoutWithIslandIds.value[shortTitle] = builder.productLayoutOptions[i].id;
    } else {
      tempProductLayoutNoIslandIds.value[shortTitle] = builder.productLayoutOptions[i].id;
    }
  }

});

function selectProduct(prop, opt) {

  // update item prop
  builder.setCurrentItemProp(prop, opt['id']);

  // set default product layout if a valid one isn't already selected
  const results = builder.productLayoutOptions.filter(obj => {
    return obj.id === builder.currentItem.productLayoutId && obj.productId === builder.currentItem.productId;
  });
  const defaultProductLayoutId = tempProductLayoutIds.value[builder.currentItem.productId] ?? opt.defaultProductLayoutId;
  if (!results.length) builder.setCurrentItemProp('productLayoutId', defaultProductLayoutId);

}

function selectProductLayout(prop, opt) {

  const shortTitle = opt['title'].replace(' with Island', '');
  tempProductLayoutSelection.value = shortTitle;

  // update item prop
  builder.setCurrentItemProp(prop, opt['id']);

  // save product layout id against a product id temporarily so user can switch back and forth easily
  tempProductLayoutIds.value[builder.currentItem.productId] = opt.id

  // one-click continue
  builder.saveCurrentItem(true);

}

function select(prop, opt) {

  // change the selected product layout to the equivalent with or without island
  let newProductLayoutId = null;
  if (opt['id']) {
    newProductLayoutId = tempProductLayoutWithIslandIds.value[tempProductLayoutSelection.value];
  } else {
    newProductLayoutId = tempProductLayoutNoIslandIds.value[tempProductLayoutSelection.value];
  }
  if (!_.isNull(newProductLayoutId)) builder.setCurrentItemProp('productLayoutId', newProductLayoutId);

  builder.setCurrentItemSpec(prop, opt['id']);

}

function createCustomKitchen() {

  builder.currentItem.productId = 4;
  builder.currentItem.productLayoutId = 14;
  builder.saveCurrentItem(true, false);

}



const isChangingLayout = computed(() => {
  if (builder.currentItem.validStep > 1 && builder.currentItem.productLayoutId !== originalProductLayoutId) {
    return true
  }
  return null;
})

// init refs
let refHandles = [
  'productLayoutIdGroup'
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>
